import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const PROVINCES = ["ON", "QC", "BC", "AB", "MB", "SK", "NS", "NB", "NL", "PE"];

export default function PostJob() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({ title: "", description: "", category: "", city: "", province: "ON", budget_min: 50, budget_max: 200 });
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/categories").then((r) => setCategories(r.data)); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/jobs", {
        ...form,
        budget_min: parseFloat(form.budget_min),
        budget_max: parseFloat(form.budget_max),
      });
      toast.success("Job posted");
      navigate(`/jobs/${data.job_id}`);
    } catch (e) {
      toast.error("Could not post job");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-24 pb-16 max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-2">New Job</div>
        <h1 className="font-display text-4xl mb-8">Post a job</h1>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Title</label>
            <input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="w-full border border-slate-300 px-3 py-2.5" data-testid="job-title" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Description</label>
            <textarea required rows={5} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="w-full border border-slate-300 px-3 py-2.5" data-testid="job-description" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Category</label>
              <select required value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} className="w-full border border-slate-300 px-3 py-2.5" data-testid="job-category">
                <option value="">Select…</option>
                {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Province</label>
              <select value={form.province} onChange={(e) => setForm({ ...form, province: e.target.value })} className="w-full border border-slate-300 px-3 py-2.5" data-testid="job-province">
                {PROVINCES.map((p) => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">City</label>
              <input required value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} className="w-full border border-slate-300 px-3 py-2.5" data-testid="job-city" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Budget min (CAD)</label>
              <input required type="number" min={0} value={form.budget_min} onChange={(e) => setForm({ ...form, budget_min: e.target.value })} className="w-full border border-slate-300 px-3 py-2.5" data-testid="job-budget-min" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Budget max (CAD)</label>
              <input required type="number" min={0} value={form.budget_max} onChange={(e) => setForm({ ...form, budget_max: e.target.value })} className="w-full border border-slate-300 px-3 py-2.5" data-testid="job-budget-max" />
            </div>
          </div>
          <button type="submit" disabled={busy} className="bg-brand text-white px-6 py-3 font-semibold hover:bg-[#122148] disabled:opacity-50" data-testid="post-job-submit">
            {busy ? "Posting…" : "Post job"}
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
}
